///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2026, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2026 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////
import { Point3d } from "./Common/Geometry";
import { OdBaseCuttingPlaneDragger } from "./OdBaseCuttingPlaneDragger";

export class OdCuttingPlaneZAxisDragger extends OdBaseCuttingPlaneDragger {
  override createNormal(): number[] {
    return [0, 0, -1];
  }

  override handleDelta(delta: Point3d): Point3d {
    delta.x = 0.0;
    delta.y = 0.0;
    return delta;
  }

  override getPlanePreviewCoordinate(): number[] {
    const halfSize = this.m_size / 2;
    return [
      this.m_center.x - halfSize,
      this.m_center.y - halfSize,
      this.m_center.z,
      this.m_center.x + halfSize,
      this.m_center.y - halfSize,
      this.m_center.z,
      this.m_center.x + halfSize,
      this.m_center.y + halfSize,
      this.m_center.z,
      this.m_center.x - halfSize,
      this.m_center.y + halfSize,
      this.m_center.z,
    ];
  }
}
